import { getUserInfo, setUserInfo, removeUserInfo } from "@/utils/auth";

export default {
  state: {
    userInfo: getUserInfo(),
    cartVisible: false,
    buyVisible: false,
    checkedList: [],
    cartBadge: '',
    bellBadge: '',
    buttonStatus: null,
    changeRules: false,
    countNumHY: null,
    countNumMF: null,
    TotalCoins: null,
    totalpoints: null,
    byCountNumHYRest: null,
    byCountNumMFRest: null,
    hjCountNumHYRest: null,
    hjCountNumMFRest: null,
    ptCountNumMFRest: null,
    jslists: [],
  },
  getters: {
    GET_USER_INFO (state) {
      return state.userInfo;
    },
    GET_CART_VISIBLE (state) {
      return state.cartVisible;
    },
    GET_BUY_VISIBLE (state) {
      return state.buyVisible;
    },
    Get_CHECK_LIST(state){
      return state.checkedList
    },
    GET_JS_LISTS(state){
      return state.jslists
    },
    Get_COUNT_HY(state){
      return state.countNumHY
    },
    Get_COUNT_MF(state){
      return state.countNumMF
    },
    GET_CART_BADGE: state => state.cartBadge,
    GET_BELL_BADGE: state => state.bellBadge,
    SET_BTN_TYPE: state => state.buttonStatus,
    SET_CHANGERULES_STATE: state => state.changeRules,
    GET_TOTAL_CONIS:state=>state.TotalCoins,
    GET_TOTAL_POINTS:state=>state.totalpoints,
    GET_BY_COUNT_NUM_HY_REST: state=>state.byCountNumHYRest,
    GET_BY_COUNT_NUM_MF_REST: state=>state.byCountNumMFRest,
    GET_HJ_COUNT_NUM_HY_REST: state=>state.hjCountNumHYRest,
    GET_HJ_COUNT_NUM_MF_REST: state=>state.hjCountNumMFRest,
    GET_PT_COUNT_NUM_MF_REST: state=>state.ptCountNumMFRest,
  },
  mutations: {
    SET_USER_INFO (state, payload) {
      const obj = Object.assign({}, state.userInfo, payload);
      setUserInfo(obj);
      state.userInfo = obj;
    },
    REMOVE_USER_INFO (state) {
      removeUserInfo();
      state.userInfo = getUserInfo();
    },
    SET_CART_VISIBLE (state, payload) {
      state.cartVisible = payload;
    },
    SET_BUY_VISIBLE (state, payload) {
      state.buyVisible = payload;
    },
    SET_CHECKED_LIST(state, payload){
      state.checkedList = payload;
    },
    SET_JS_LISTS(state, payload){
      state.jslists = payload;
    },
    SET_COUNT_HY(state, payload){
      state.countNumHY = payload;
    },
    SET_COUNT_MF(state, payload){
      state.countNumMF = payload;
    },
    SET_CART_BADGE (state, payload) {
      state.cartBadge = payload;
    },
    SET_BELL_BADGE (state, payload) {
      state.bellBadge = payload;
    },
    SET_BTN_TYPE (state, buttonStatus) {
      state.buttonStatus = buttonStatus
    },
    SET_CHANGERULES_STATE (state, buttonStatus){
     state.changeRules = buttonStatus
    },
    SET_TOTAL_COINS(state,val){
      state.TotalCoins = val
    },
    SET_TOTAL_POINTS(state,val){
      state.totalpoints = val
    },
    SET_BY_COUNT_NUM_HY_REST(state,val){
      state.byCountNumHYRest = val
    },
    SET_BY_COUNT_NUM_MF_REST(state,val){
      state.byCountNumMFRest = val
    },
    SET_HJ_COUNT_NUM_HY_REST(state,val){
      state.hjCountNumHYRest = val
    },
    SET_HJ_COUNT_NUM_MF_REST(state,val){
      state.hjCountNumMFRest = val
    },
    SET_PT_COUNT_NUM_MF_REST(state,val){
      state.ptCountNumMFRest = val
    },
    clearMemberCount(state){
      state.memberCount = null
    }
  },
  actions: {
  },
};
